import get from 'lodash/get'

export default {
  current: state => get(state, 'current'),
  queue: state => get(state, 'jobs', []),
}
